import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
import { shuffle } from "@/utils/numUtils";

var VipPurchaseSuccessToast =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipPurchaseSuccessToast, _Vue);

  function VipPurchaseSuccessToast() {
    var _this;

    _classCallCheck(this, VipPurchaseSuccessToast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipPurchaseSuccessToast).apply(this, arguments));
    _this.isShow = false;
    return _this;
  }

  _createClass(VipPurchaseSuccessToast, [{
    key: "clickItem",
    value: function clickItem(fn) {
      this.closeToast();
      fn && fn();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      EventBus.$on("vip-purchase-success-toast-show", function () {
        _this2.isShow = true;

        _this2.updateResultByName({
          name: "canShowSuccessToast",
          result: false
        });
      });
    }
  }, {
    key: "closeToast",
    value: function closeToast() {
      this.isShow = false;
    }
  }, {
    key: "recommendList",
    get: function get() {
      var functionList = this.tempFunctionList("functionList");
      var hotList = this.tempFunctionList("functionList").filter(function (v) {
        return v.group && v.group === 'hot';
      });
      var resultList = hotList.length >= 2 ? shuffle(hotList) : shuffle(functionList);
      return resultList.slice(0, 2);
    }
  }]);

  return VipPurchaseSuccessToast;
}(Vue);

tslib_1.__decorate([Getter(types.GETTER_TEMP_RESULT_BY_NAME)], VipPurchaseSuccessToast.prototype, "tempFunctionList", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipPurchaseSuccessToast.prototype, "updateResultByName", void 0);

VipPurchaseSuccessToast = tslib_1.__decorate([Component({
  components: {}
})], VipPurchaseSuccessToast);
export default VipPurchaseSuccessToast;